'use client';

import { useEffect } from 'react';

import { useAuthContext } from '@/lib/contexts/auth';
import { useConsent } from '@/lib/contexts/consent/ConsentProvider';

import { useAnalytics } from './useAnalytics';

export const useAnalyticsIdentity = () => {
  const { identify, reset } = useAnalytics();
  const { isAuthenticated, loading, getUserDataField } = useAuthContext();
  const { hasConsent, consentVersion } = useConsent();

  useEffect(() => {
    // Session still loading → wait, don't reset
    if (loading) return;

    const analyticsConsented = hasConsent('analytics');

    // No consent → clear identity
    if (!analyticsConsented) {
      reset();
      return;
    }

    // Definitively not logged in → clear identity
    if (!isAuthenticated) {
      reset();
      return;
    }

    const userId = getUserDataField(user => user.id);

    // userData not yet available → wait for userDataUpdated event
    if (!userId) return;

    const email = getUserDataField(user => user.email);
    const language = getUserDataField(user => user.language);
    const country = getUserDataField(user => user.country);
    const subscriptionStatus = getUserDataField(
      user => user.subscription?.status,
    );

    identify({
      id: String(userId),
      traits: {
        email,
        language,
        country,
        subscription_status: subscriptionStatus,
      },
    });
  }, [
    identify,
    reset,
    loading,
    isAuthenticated,
    hasConsent,
    consentVersion,
    getUserDataField,
  ]);
};
